import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import moment from 'moment'

// import { upgradeStore } from '@views/ordering/upgrade/actor/store' // 查询列表
// import moment from 'moment'

class UpgradesStore extends StoreExt {
    @observable loadingStatus: boolean = false
    @observable upgradesList: any[] = []  // 可升级套餐列表
    @observable usePackage: any[] = []

    @action
    getList = async (simId) => {
        if (simId) {
            runInAction(() => this.loadingStatus = true)
            try {
                const res = await this.api.queryUserGoodsChange({simId})
                res.map(item => {
                    if (moment(new Date()).diff(moment(item.startDate), 'days') >= 0 &&
                        moment(new Date()).diff(moment(item.endDate), 'days') <= 0 || item.inUse === 1) {
                        item.useStatus = 1   // 正在使用
                    } else if (moment(new Date()).diff(moment(item.startDate), 'days') < 0 || item.inUse === 0) {
                        item.useStatus = 0   // 未使用
                    }
                })
                const res1 = res.filter(item => item.allowUpgrade === '1') // 只取可待升级的 套餐
                runInAction(() => {
                    this.loadingStatus = false
                    this.upgradesList = res1
                })
            } catch (e) {
                runInAction(() => this.loadingStatus = false)
            }
        }
    }

    @action
    clearUpgradesList = () => runInAction(() => this.upgradesList = [])
}

const upgradesStore = new UpgradesStore()
export {
    upgradesStore,
    UpgradesStore
}
